import { createContext, useContext, useMemo, useState } from "react";
import { useSocket } from "../../../Context/SocketContext";
import { useEffect } from "react";
import { filter } from "lodash";
import useSearchFilter from "../../../Hooks/useSearchFilter";

export const ChatContext = createContext();

export const useChatContext = () => {
  return useContext(ChatContext);
};

export default function ChatContextProvider({ children }) {
  const { socket, isSocketConnected } = useSocket();

  //   console.log(`isSocketConnected`, isSocketConnected);

  const INITIAL_CHAT_THREAD = useMemo(() => {
    return {
      isError: false,
      isLoading: true,
      data: [],
    };
  });

  const [search, setSearch] = useState("");
  const [chatRoom, setChatRoom] = useState({});
  const [chatThread, setChatThread] = useState(INITIAL_CHAT_THREAD);

  //   console.log(`chatRoom`, chatRoom);
  // console.log(`chatThread`, chatThread);

  const filteredThread = useSearchFilter(chatThread, search, "room_name");
  // console.log(`filteredThread`, filteredThread);

  useEffect(() => {
    if (!isSocketConnected) return;

    socket.emit("_getChatThreads");
  }, [isSocketConnected, socket]);

  useEffect(() => {
    if (isSocketConnected) {
      socket.on("getChatThreads_", (data) => {
        // console.log(data);
        setChatThread((prev) => {
          return {
            ...prev,
            isLoading: false,
            data: data?.data || [],
          };
        });
      });
    }

    return () => {
      if (isSocketConnected) {
        socket.dispose("getChatThreads_");
      }
    };
  }, [isSocketConnected, socket]);

  useEffect(() => {
    if (!isSocketConnected) return;

    socket.on("receivedMessage_", (res) => {
      const data = res?.data || {};
      setChatThread((prev) => {
        return {
          ...prev,
          data: prev?.data.map((item) => {
            if (item.chat_room_id !== data?.chat_room_id) return item;
            return {
              ...item,
              message: {
                ...item?.message,
                message_type: data?.message_type,
                message: data?.message,
                createdAt: data?.message_timestamp,
              },
              unread_message_count:
                chatRoom?.id === data?.chat_room_id
                  ? item?.unread_message_count
                  : item?.unread_message_count + 1,
            };
          }),
        };
      });
    });
  }, [isSocketConnected, chatRoom, socket]);

  const resetMessageCount = (chat_room_id) => {
    setChatThread((prev) => {
      return {
        ...prev,
        data: prev?.data.map((item) => {
          if (item.chat_room_id !== chat_room_id) return item;
          return {
            ...item,
            unread_message_count: 0,
          };
        }),
      };
    });
  };

  const updateLastMessagePayload = (data) => {
    setChatThread((prev) => {
      return {
        ...prev,
        data: prev?.data.map((item) => {
          if (item.chat_room_id !== data?.chat_room_id) return item;
          return {
            ...item,
            message: {
              ...item?.message,
              message_type: data?.message_type,
              message: data?.message,
              createdAt: data?.message_timestamp,
            },
          };
        }),
      };
    });
  };

  return (
    <ChatContext.Provider
      value={{
        // chatThreads: chatThread,
        chatThreads: filteredThread,
        chatRoom,
        setChatRoom,
        resetMessageCount,
        updateLastMessagePayload,
        search,
        setSearch,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
}
